module.exports = __webpack_public_path__ + "img/4.c0db13fe.png";